"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import { API_HOST } from "config"
var _default = function _default(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // const {
  //   baseUrl = API_HOST
  // } = options;
  var ImgLoaderWrapper = /*#__PURE__*/function (_React$Component) {
    _inherits(ImgLoaderWrapper, _React$Component);

    var _super = _createSuper(ImgLoaderWrapper);

    function ImgLoaderWrapper() {
      var _this;

      _classCallCheck(this, ImgLoaderWrapper);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "state", {
        loading: false,
        message: ""
      });

      return _this;
    }

    _createClass(ImgLoaderWrapper, [{
      key: "uploadImage",
      value: function uploadImage(file) {
        var _this2 = this;

        if (!file) return Promise.resolve(null);

        if (!/^image[/]/.test(file.type)) {
          this.setState({
            message: "File was not an image."
          });
          return Promise.resolve(null);
        }

        var filename = file.name.replace(/\s+/g, "_");
        this.setState({
          message: "",
          loading: true
        });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        return new Promise(function (resolve) {
          reader.addEventListener("load", function () {
            fetch("".concat(_this2.props.imgUploadUrl, "/upload/").concat(filename), {
              method: "POST",
              body: reader.result,
              headers: {
                "Content-Type": "application/octet-stream",
                "Authorization": window.localStorage.getItem("userToken")
              }
            }).then(function (res) {
              if (!res.ok) {
                resolve({
                  url: null
                });
              }

              return res.json();
            }).then(resolve);
          });
        }).then(function (_ref) {
          var url = _ref.url;

          _this2.setState({
            loading: false
          });

          return {
            url: url,
            filename: filename
          };
        });
      }
    }, {
      key: "editImage",
      value: function editImage(src, filename, action, args) {
        var _this3 = this;

        this.setState({
          loading: true
        });
        return new Promise(function (resolve) {
          fetch("".concat(_this3.props.imgUploadUrl, "/edit/").concat(filename, "/").concat(action, "/").concat(args), {
            method: "POST",
            body: JSON.stringify({
              src: encodeURI(src)
            }),
            headers: {
              "Content-Type": "application/json",
              "Authorization": window.localStorage.getItem("userToken")
            }
          }).then(function (res) {
            if (!res.ok) {
              resolve({
                url: null
              });
            }

            return res.json();
          }).then(resolve);
        }).then(function (_ref2) {
          var url = _ref2.url;

          _this3.setState({
            loading: false
          });

          return url;
        });
      }
    }, {
      key: "saveImage",
      value: function saveImage(src, filename, history) {
        var _this4 = this;

        this.setState({
          loading: true
        });
        return new Promise(function (resolve) {
          fetch("".concat(_this4.props.imgUploadUrl, "/save/").concat(filename), {
            method: "POST",
            body: JSON.stringify({
              src: src,
              history: history
            }),
            headers: {
              "Content-Type": "application/json",
              "Authorization": window.localStorage.getItem("userToken")
            }
          }).then(function (res) {
            if (!res.ok) {
              resolve({
                url: null
              });
            }

            return res.json();
          }).then(resolve);
        }).then(function (_ref3) {
          var url = _ref3.url;

          _this4.setState({
            loading: false
          });

          return url;
        });
      }
    }, {
      key: "render",
      value: function render() {
        var _this5 = this;

        var _this$props = this.props,
            forwardRef = _this$props.forwardRef,
            props = _objectWithoutProperties(_this$props, ["forwardRef"]);

        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, props, this.state, {
          ref: forwardRef,
          uploadImage: function uploadImage() {
            return _this5.uploadImage.apply(_this5, arguments);
          },
          editImage: function editImage() {
            return _this5.editImage.apply(_this5, arguments);
          },
          saveImage: function saveImage() {
            return _this5.saveImage.apply(_this5, arguments);
          }
        }));
      }
    }]);

    return ImgLoaderWrapper;
  }(_react["default"].Component);

  _defineProperty(ImgLoaderWrapper, "propTypes", {
    imgUploadUrl: _propTypes["default"].string.isRequired
  });

  return /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
    return /*#__PURE__*/_react["default"].createElement(ImgLoaderWrapper, _extends({}, props, {
      forwardRef: ref
    }));
  });
};

exports["default"] = _default;